






























import { computed, defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'
import useI18n from '@/composables/use-i18n'
import useProxyValue from '@/composables/use-proxy-value'
import CustomSelectItem from '@/interfaces/CustomSelectItem'

export default defineComponent({
  props: {
    value: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    multiRow: {
      type: Boolean,
      default: false,
    },
    chippyCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const i18n = useI18n()
    const { proxyValue } = useProxyValue(toRefs(props).value, emit)
    const itemClass = computed(() => {
      if (props.chippyCheckbox) return ''
      return props.multiRow ? 'min-w-1/3' : 'w-full'
    })
    const list: CustomSelectItem[] = [
      {
        value: 2,
        name: i18n.t('filter.equipment.option.gps') as string,
      },
    ]

    watch(proxyValue, (value) => {
      emit('update', list.filter(item => value.includes(item.value)))
    }, { immediate: true })

    return {
      proxyValue,
      itemClass,
      list,
    }
  },
})
